import {environment} from '../../../environments/environment';

export function localeFallback(locale: string) {
  let userLocale = locale.indexOf('_') != -1 ? locale.replace("_", "-") : locale;
  let targetLocale = environment.locales.find(item => item.locale === userLocale);
  let theLocale = (targetLocale) ? targetLocale.locale : environment.defaultLocale;
  return theLocale;
}
